@if(this.settingService.configuration.uIoptions.homePageOption == 10) {
  <ion-header>
    <ion-toolbar  class="alteredTopBar">
      <ion-buttons slot="start">
        <ion-menu-button (click)="closePopup()"></ion-menu-button>
      </ion-buttons>
      <ion-title>
        <div class="titleBar alternateTitelBar">
          <div class="title">
            {{ title  | translate }}
          </div>
          
          <div class="titleImg">
            <!--replace this for a setting maybe for the image?-->
            <img class="Img-style" src="assets/tempimgs/bitten-donut.png" alt="">
          </div>


        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
} @else {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-button (click)="closePopup()"></ion-menu-button>
      </ion-buttons>
      <ion-title>
        <div class="titleBar">
          {{ title  | translate }}

          @if (NotificationService.showNotificationBell && mobile) {
            <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
              <div class="bellimgContainer">
                <!--<fa-icon icon="bell" id="bellsize"></fa-icon>-->
                <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                <!--<img id="bellsize" src="../../../../assets/icon/notification/bell.png" alt="">-->
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
}





<ion-content [fullscreen]="false" id="ion-content" style="overscroll-behavior: contain;">
  @if ((mobile  && !settingService.navigationSetting) && settingService.configuration.uIoptions) {
    <app-undocked-navigation-bar style="position: absolute; z-index: 10;" [disabledOption]="'Nav.Stores'"></app-undocked-navigation-bar>
  }

  <ion-grid class="ion-grid-layout" id="ion-grid">

    <ion-row class="order-type-container">
      @if (allowPickup) {
        <ion-col>
          @if (this.settingService.configuration.uIoptions.homePageOption == 10) {
            <!--
            <ion-card class="order-type alteredStyle-order-type" [color]="getOrderTypeColor('pickup')" (click)="changeOrderType('pickup'); closeScanner();">
              <ion-card-header class="order-type-layout">
                <ion-icon name="basket" class="order-type-img alteredStyle-ion-icon"></ion-icon>
                <ion-card-title class="alteredStyle-ion-card-title">{{ 'Store.DeliveryType.Pickup' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
            -->
            <ion-card class="order-type alteredStyle-order-type alt-color-order-type"  (click)="changeOrderType('pickup'); closeScanner();">
              <ion-card-header class="order-type-layout">
                <ion-icon name="basket" class="order-type-img alteredStyle-ion-icon" style="color: white;"></ion-icon>
                <ion-card-title class="alteredStyle-ion-card-title" style="color: white;">{{ 'Store.DeliveryType.Pickup' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          } @else {
            <ion-card class="order-type" [color]="getOrderTypeColor('pickup')" (click)="changeOrderType('pickup'); closeScanner();">
              <ion-card-header class="order-type-layout">
                <ion-icon name="basket" class="order-type-img"></ion-icon>
                <ion-card-title >{{ 'Store.DeliveryType.Pickup' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          }

        </ion-col>
      }

      @if (allowDelivery) {
        <ion-col>

          @if (this.settingService.configuration.uIoptions.homePageOption == 10) {
            <!--
            <ion-card class="order-type alteredStyle-order-type" [color]="getOrderTypeColor('delivery')" (click)="changeOrderType('delivery'); closeScanner();">
              <ion-card-header class="order-type-layout">
                <ion-icon name="car" class="order-type-img alteredStyle-ion-icon"></ion-icon>
                <ion-card-title class="alteredStyle-ion-card-title">{{ 'Store.DeliveryType.Delivery' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
            -->
            <ion-card class="order-type alteredStyle-order-type alt-color-order-type" (click)="changeOrderType('delivery'); closeScanner();">
              <ion-card-header class="order-type-layout">
                <ion-icon name="car" class="order-type-img alteredStyle-ion-icon" style="color: white;"></ion-icon>
                <ion-card-title class="alteredStyle-ion-card-title" style="color: white;">{{ 'Store.DeliveryType.Delivery' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          } @else {
            <ion-card class="order-type" [color]="getOrderTypeColor('delivery')" (click)="changeOrderType('delivery'); closeScanner();">
              <ion-card-header class="order-type-layout">
                <ion-icon name="car" class="order-type-img"></ion-icon>
                <ion-card-title>{{ 'Store.DeliveryType.Delivery' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          }
          
        </ion-col>
      }

      @if (allowShipping && isRetail) {
        <ion-col>
          @if (this.settingService.configuration.uIoptions.homePageOption == 10) {
            <!--
            <ion-card class="order-type alteredStyle-order-type" [color]="getOrderTypeColor('shipping')" (click)="changeOrderType('shipping'); closeScanner();">
              <ion-card-header class="order-type-layout">
                <ion-icon name="cube" class="order-type-img alteredStyle-ion-icon"></ion-icon>
                <ion-card-title class="alteredStyle-ion-card-title">{{'Store.ShippingOrderType' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
            -->
            <ion-card class="order-type alteredStyle-order-type alt-color-order-type"  (click)="changeOrderType('shipping'); closeScanner();">
              <ion-card-header class="order-type-layout">
                <ion-icon name="cube" class="order-type-img alteredStyle-ion-icon" style="color: white;"></ion-icon>
                <ion-card-title class="alteredStyle-ion-card-title" style="color: white;">{{'Store.ShippingOrderType' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          } @else {
            <ion-card class="order-type" [color]="getOrderTypeColor('shipping')" (click)="changeOrderType('shipping'); closeScanner();">
              <ion-card-header class="order-type-layout">
                <ion-icon name="cube" class="order-type-img"></ion-icon>
                <ion-card-title>{{'Store.ShippingOrderType' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          }
          
        </ion-col>
      }

      @if (allowTable) {
        <ion-col>
          @if (this.settingService.configuration.uIoptions.homePageOption == 10) {
            <!--
            <ion-card class="order-type alteredStyle-order-type" [color]="getOrderTypeColor('table')" (click)="changeOrderType('table');">
              <ion-card-header class="order-type-layout">
                <ion-icon name="storefront" class="order-type-img alteredStyle-ion-icon"></ion-icon>
                <ion-card-title class="alteredStyle-ion-card-title">{{'Store.DeliveryType.Table' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
            -->
            <ion-card class="order-type alteredStyle-order-type alt-color-order-type" (click)="changeOrderType('table');">
              <ion-card-header class="order-type-layout">
                <ion-icon name="storefront" class="order-type-img alteredStyle-ion-icon" style="color: white;"></ion-icon>
                <ion-card-title class="alteredStyle-ion-card-title" style="color: white;">{{'Store.DeliveryType.Table' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          } @else {
            <ion-card class="order-type" [color]="getOrderTypeColor('table')" (click)="changeOrderType('table');">
              <ion-card-header class="order-type-layout">
                <ion-icon name="storefront" class="order-type-img"></ion-icon>
                <ion-card-title>{{'Store.DeliveryType.Table' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          }
        </ion-col>
      }

      @if (allowSeat) {
        <ion-col>
          
          
          @if (this.settingService.configuration.uIoptions.homePageOption == 10) {
            <ion-card class="order-type alteredStyle-order-type" [color]="getOrderTypeColor('seat')" (click)="changeOrderType('seat');">
              <ion-card-header class="order-type-layout">
                <svg style="margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path fill="currentColor" d="M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2z"/></svg>
                <ion-card-title class="alteredStyle-ion-card-title">{{'Store.DeliveryType.Seat' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          } @else {
            <ion-card class="order-type" [color]="getOrderTypeColor('seat')" (click)="changeOrderType('seat');">
              <ion-card-header class="order-type-layout">
                <svg style="margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2z"/></svg>
                <ion-card-title>{{'Store.DeliveryType.Seat' | translate}}</ion-card-title>
              </ion-card-header>
            </ion-card>
          }
        </ion-col>
      }
    </ion-row>

  </ion-grid>

  @if (this.orderType == 'delivery') {
    <div class="deliveryMayApplyContainer">
      {{'Store.DeliveryMayApply' | translate}}
    </div>
  }

  @if (orderType) {
    <div style="background-color: var(--ion-color-septenary);">
      @if (orderType != 'table') {
        <div class="segmentFrame">
          @if(this.settingService.configuration.uIoptions.homePageOption == 10) {
            <ion-segment (ionChange)="segmentChanged()" [value]="pickupValue">
              @if (orderType != 'seat') {
                @if (this.settingService.configuration.uIoptions?.homePageOption == 10) {
                  <ion-segment-button [ngStyle]="orderType != 'pickup' && {'margin-left': '0px'}" class="button alteredStyle-ion-segment-button" value="address">
                    <ion-label class="segment-label alteredStyle-segment-label"> {{ 'Store.ByAddressSmall' | translate}}</ion-label>
                  </ion-segment-button>
                } @else {
                  <ion-segment-button [ngStyle]="orderType != 'pickup' && {'margin-left': '0px'}" class="button alteredStyle-ion-segment-button" value="address">
                    <ion-label class="segment-label"> {{ 'Store.ByAddress' | translate}}</ion-label>
                  </ion-segment-button>
                }
                
                <!--
                <ion-segment-button [ngStyle]="orderType != 'pickup' && {'margin-left': '0px'}" class="button alteredStyle-ion-segment-button" value="address">
                  <ion-label class="segment-label alteredStyle-segment-label"> {{ 'Store.ByAddress' | translate}}</ion-label>
                </ion-segment-button>
                -->
                
              }
              @if (orderType == 'pickup') {
                @if (this.settingService.configuration.uIoptions?.homePageOption == 10) {
                  <ion-segment-button  class="button alteredStyle-ion-segment-button" value="position">
                    <ion-label class="segment-label alteredStyle-segment-label">{{ 'Store.ByPositionSmall' | translate}}</ion-label>
                  </ion-segment-button>
                } @else {
                  <ion-segment-button  class="button alteredStyle-ion-segment-button" value="position">
                    <ion-label class="segment-label">{{ 'Store.ByPosition' | translate}}</ion-label>
                  </ion-segment-button>
                }
                <!--
                <ion-segment-button  class="button alteredStyle-ion-segment-button" value="position">
                  <ion-label class="segment-label alteredStyle-segment-label">{{ 'Store.ByPosition' | translate}}</ion-label>
                </ion-segment-button>
                -->
                
              }
            </ion-segment>
          } @else {
            <ion-segment (ionChange)="segmentChanged()" [value]="pickupValue">
              @if (orderType != 'seat') {
                <ion-segment-button [ngStyle]="orderType != 'pickup' && {'margin-left': '0px'}" class="button" value="address">
                  <ion-label class="segment-label"> {{ 'Store.ByAddress' | translate}}</ion-label>
                </ion-segment-button>
              }
              @if (orderType == 'pickup') {
                <ion-segment-button  class="button" value="position">
                  <ion-label class="segment-label">{{ 'Store.ByPosition' | translate}}</ion-label>
                </ion-segment-button>
              }
            </ion-segment>
          }
          
        </div>
        @if (segmentValue && segmentValue == 'address'  && orderType != 'seat') {
          <ion-item (click)="beginChangeAddress()" class="disable-background-color hoverAddress">
            <p style="white-space: pre;">{{ (orderType == 'delivery' ? 'Store.DeliveryAddress' : (orderType=='pickup' ? 'Store.YourAddress' : 'Store.ShippingAddress' )) | translate}}</p>
            <ion-icon name="chevron-forward-outline" item-right class="animatedChevron"></ion-icon>
            @if (address) {
              <p>{{ formatedAddress }}</p>
            }
          </ion-item>
        }

        @if (geopoint) {
          <ion-grid style="background-color: var(--ion-color-septenary);" [ngClass]="{ 'AddPadding': unDockNavigationBar}" >
            <ion-row style="background-color: var(--ion-color-septenary);">
              @if (storeValidRange.length == 0) {
                <ion-col><h1> {{ 'Store.NoStoreInRange' | translate}}</h1></ion-col>
              }
              {{ incrementStoreReset() }}
              @for (store of stores; track store) {
                <ion-col style="padding:0px; min-width: 70%;">
                  @if (store && storeValidRange.includes(store) && storeDisplay < storeCap && storeMatchCartContent(store)) {
                    <a (click)="storeClicked(store)">
                      {{ incrementStore(store) }}
                      <ion-card  [class.closed]="(store._disabledPickup && orderType == 'pickup') || (store._disabledDelivery && orderType == 'delivery') || (store._disabled)" class="store">
                        <ion-card-header class="card_layout" [ngClass]="{ 'alteredStyle-card_layout': this.settingService.configuration.uIoptions.homePageOption == 10}">
                          <div class="card_PositionFlip">
                            
                            <!-- adding the store image icon -->
                            @if(this.settingService.configuration.uIoptions.homePageOption == 10) {
                              <div class="store-img-container" [ngClass]="{ 'OrderLaterAdjust': validateClosing(store) }">
                                  <ion-icon class="store-icon" slot="start" [ios]="'storefront-outline'" [md]="'storefront-sharp'" ></ion-icon>
                              </div>
                            }

                            @if (store._disabled) {
                              <div class="ion-card-left">
                                @if (!store._disabled) {
                                  <ion-card-title class="titleAdjust"><b class="storetitleopen cards-font-size" [class.text-centered]="clickedStoreId === store.id && settingService.configuration.requireTimeOfOrder" [ngClass]="{ 'alt_titleAdjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.displayName }}</b></ion-card-title>
                                }
                                @if (store._disabled) {
                                  <ion-card-title class="titleAdjust"><b class="storetitleclose cards-font-size" [class.text-centered]="clickedStoreId === store.id && settingService.configuration.requireTimeOfOrder" [ngClass]="{ 'alt_titleAdjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.displayName }}</b></ion-card-title>
                                }
                                <div class="FlexLayout" [class.text-centered]="clickedStoreId === store.id && settingService.configuration.requireTimeOfOrder">
                                  <ion-card-subtitle class="text_adjust store_text_address" 
                                  [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                  'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ getStoreAddress(store.address) }}</ion-card-subtitle>

                                  @if (((!store._disabledPickup && orderType == 'pickup') || (!store._disabledDelivery && orderType == 'delivery') || (!store._disabled) || mobile) || (orderType == 'delivery' || orderType == 'shipping')) {
                                    <div class="linelayout">
                                      @if ((store._disabledPickup && orderType == 'pickup') || (store._disabledDelivery && orderType == 'delivery') || (store._disabled)) {
                                        <div>
                                          <ion-card-subtitle class="store_preclosingmessage" [class.status-open]="(!store._disabledPickup && orderType == 'pickup') || (!store._disabledDelivery && orderType == 'delivery') || (!store._disabled)" [class.status-closed]="(store._disabledPickup && orderType == 'pickup') || (store._disabledDelivery && orderType == 'delivery') || (store._disabled)">{{ store._status | translate}}
                                            @if ((store.orderPrepareTimeMin || store.PrepareTimeMax) && !store._disabled) {
                                              <span> • {{ (store.orderPrepareTimeMax ? store.orderPrepareTimeMax : 0) }} min {{ 'Store.Delay' | translate}}</span>
                                            }
                                          </ion-card-subtitle>
                                        </div>
                                      }
                                      @if ((!store._disabledPickup && orderType == 'pickup') || (!store._disabled)) {
                                        <div>
                                          @if (store.openHours.length > 0 && store._openHour && orderType != 'delivery' && orderType != 'pickup' ) {
                                            <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                            'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openHour}} - {{store._closedHour}}</ion-card-subtitle>
                                          }
                                          @if (store.openHours.length > 0 && store._openDeliveryHour && orderType == 'delivery') {
                                            <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                            'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openDeliveryHour}} - {{store._closeDeliveryHour}}</ion-card-subtitle>
                                          }
                                          @if (store.openHours.length > 0 && store._openPickupHour && orderType == 'pickup') {
                                            <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                            'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openPickupHour}} - {{store._closePickupHour}}</ion-card-subtitle>
                                          }
                                        </div>
                                      }
                                      <ion-card-subtitle class="text_adjust noWrapping" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">
                                        {{ store._distance | number:'1.2-2' }} km 
                                        @if (store.timeMin) {
                                          <span>• {{ store.timeMin }}-{{ store.timeMax }} Min • $</span>
                                        }
                                      </ion-card-subtitle>
                                    </div>
                                  }
                                  @if (orderType != 'delivery' && orderType != 'shipping' && store._disabledPickup && !mobile) {
                                    <div class="linelayout">
                                      @if ((store._disabledPickup && orderType == 'pickup') || (store._disabled)) {
                                        <div>
                                          <ion-card-subtitle class="store_preclosingmessage" [class.status-open]="(!store._disabledPickup && orderType == 'pickup') || (!store._disabled)" [class.status-closed]="(store._disabledPickup && orderType == 'pickup') || (store._disabled)">{{ store._status | translate}}
                                            @if ((store.orderPrepareTimeMin || store.PrepareTimeMax) && !store._disabled) {
                                              <span> • {{ (store.orderPrepareTimeMax ? store.orderPrepareTimeMax : 0) }} min {{ 'Store.Delay' | translate}}</span>
                                          }</ion-card-subtitle>
                                        </div>
                                      }
                                      @if ((!store._disabledPickup && orderType == 'pickup') || (!store._disabled)) {
                                        <div>
                                          @if (store.openHours.length > 0 && store._openHour && orderType != 'pickup' ) {
                                            <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                            'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openHour}} - {{store._closedHour}}</ion-card-subtitle>
                                          }
                                          @if (store.openHours.length > 0 && store._openPickupHour && orderType == 'pickup') {
                                            <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                            'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openPickupHour}} - {{store._closePickupHour}}</ion-card-subtitle>
                                          }
                                        </div>
                                      }
                                      <ion-card-subtitle class="text_adjust noWrapping" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">
                                        {{ store._distance | number:'1.2-2' }} km 
                                        @if (store.timeMin) {
                                          <span>• {{ store.timeMin }}-{{ store.timeMax }} Min • $</span>
                                        }
                                      </ion-card-subtitle>
                                    </div>
                                  }
                                </div>
                                @if ((store.convenienceFee > 0.00) && !store._disabledPickup) {
                                  <div class="FlexLayout">
                                    <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.convenienceFee | currency}} {{ 'Store.ConvenienceFee' | translate}} </ion-card-subtitle>
                                  </div>
                                }

                                <div class="FlexLayout">
                                  @if (orderType == 'delivery') {
                                    <div>
                                      @if (store.deliveryMinAmount > 0) {
                                        <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.deliveryMinAmount | currency}} {{ 'Store.minDeliveryAmount' | translate}}</ion-card-subtitle>
                                      }
                                      @if (store.deliveryPrice > 0.00) {
                                        <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.deliveryPrice | currency }} {{ 'Store.Delivery' | translate}}
                                          @if (store.freeDelivery) {
                                            @if (store.freeDelivery.isAllowed) {
                                              <span style="color: red;">/ {{ 'Store.FreeOver' | translate}} {{ store.freeDelivery.price | currency }}</span>
                                            }
                                          }
                                        </ion-card-subtitle>
                                      }
                                    </div>
                                  }
                                  @if (orderType == 'shipping') {
                                    <div>
                                      @if (store.shippingMinAmount > 0) {
                                        <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.shippingMinAmount | currency}} {{ 'Store.minShippingAmount' | translate}}</ion-card-subtitle>
                                      }
                                      @if (store.freeShipping) {
                                        <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">
                                          @if (store.freeShipping.isAllowed) {
                                            <span style="color: red;">{{ 'General.Shipping' | translate}} {{ 'Store.freeOver' | translate}} {{ store.freeShipping.price | currency }}</span>
                                          }
                                        </ion-card-subtitle>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            @if (!store._disabled) {
                              <div class="ion-card-left">
                                @if (!store._disabled) {
                                  <ion-card-title><b class="titleAdjust storetitleopen cards-font-size" [class.text-centered]="clickedStoreId === store.id && settingService.configuration.requireTimeOfOrder" [ngClass]="{ 'alt_titleAdjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.displayName }}</b></ion-card-title>
                                }
                                @if (store._disabled) {
                                  <ion-card-title><b class="titleAdjust storetitleclose cards-font-size" [class.text-centered]="clickedStoreId === store.id && settingService.configuration.requireTimeOfOrder" [ngClass]="{ 'alt_titleAdjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.displayName }}</b></ion-card-title>
                                }
                                <div class="FlexLayout" [class.text-centered]="clickedStoreId === store.id && settingService.configuration.requireTimeOfOrder">
                                  <ion-card-subtitle class="text_adjust store_text_address" 
                                  [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                  'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ getStoreAddress(store.address) }}</ion-card-subtitle>
                                  @if (((!store._disabledPickup && orderType == 'pickup') || (!store._disabledDelivery && orderType == 'delivery') || (!store._disabled) || mobile) || (orderType == 'delivery' || orderType == 'shipping')) {
                                    <div class="linelayout">
                                      @if ((store._disabledPickup && orderType == 'pickup') || (store._disabledDelivery && orderType == 'delivery') || (store._disabled)) {
                                        <div>
                                          <ion-card-subtitle class="store_preclosingmessage" [class.status-open]="(!store._disabledPickup && orderType == 'pickup') || (!store._disabledDelivery && orderType == 'delivery') || (!store._disabled)" [class.status-closed]="(store._disabledPickup && orderType == 'pickup') || (store._disabledDelivery && orderType == 'delivery') || (store._disabled)">{{ store._status | translate}}
                                            @if ((store.orderPrepareTimeMin || store.PrepareTimeMax) && !store._disabled) {
                                              <span> • {{ (store.orderPrepareTimeMax ? store.orderPrepareTimeMax : 0) }} min {{ 'Store.Delay' | translate}}</span>
                                            }
                                          </ion-card-subtitle>
                                        </div>
                                      }
                                      @if ((!store._disabledPickup && orderType == 'pickup') || (!store._disabled)) {
                                        <div>
                                          @if (store.openHours.length > 0 && store._openHour && orderType != 'delivery' && orderType != 'pickup' ) {
                                            <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                            'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openHour}} - {{store._closedHour}}</ion-card-subtitle>
                                          }
                                          @if (store.openHours.length > 0 && store._openDeliveryHour && orderType == 'delivery') {
                                            <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                            'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openDeliveryHour}} - {{store._closeDeliveryHour}}</ion-card-subtitle>
                                          }
                                          @if (store.openHours.length > 0 && store._openPickupHour && orderType == 'pickup') {
                                            <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                            'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openPickupHour}} - {{store._closePickupHour}}</ion-card-subtitle>
                                          }
                                        </div>
                                      }
                                      <ion-card-subtitle class="text_adjust noWrapping" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">
                                        {{ store._distance | number:'1.2-2' }} km 
                                        @if (store.timeMin) {
                                          <span>• {{ store.timeMin }}-{{ store.timeMax }} Min • $</span>
                                        }
                                      </ion-card-subtitle>
                                    </div>
                                  }
                                </div>
                                @if ((store.convenienceFee > 0.00) && !store._disabledPickup) {
                                  <div class="FlexLayout">
                                    <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.convenienceFee | currency}} {{ 'Store.ConvenienceFee' | translate}} </ion-card-subtitle>
                                  </div>
                                }
                                @if (orderType != 'delivery' && orderType != 'shipping' && store._disabledPickup && !mobile) {
                                  <div class="FlexLayout">
                                    @if ((store._disabledPickup && orderType == 'pickup') || (store._disabled)) {
                                      <div>
                                        <ion-card-subtitle class="store_preclosingmessage" [class.status-open]="(!store._disabledPickup && orderType == 'pickup') || (!store._disabled)" [class.status-closed]="(store._disabledPickup && orderType == 'pickup') || (store._disabled)">{{ store._status | translate}}
                                          @if ((store.orderPrepareTimeMin || store.PrepareTimeMax) && !store._disabled) {
                                            <span> • {{ (store.orderPrepareTimeMax ? store.orderPrepareTimeMax : 0) }} min {{ 'Store.Delay' | translate}}</span>
                                          }
                                        </ion-card-subtitle>
                                      </div>
                                    }
                                    @if ((!store._disabledPickup && orderType == 'pickup') || (!store._disabled)) {
                                      <div>
                                        @if (store.openHours.length > 0 && store._openHour && orderType != 'pickup' ) {
                                          <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                          'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openHour}} - {{store._closedHour}}</ion-card-subtitle>
                                        }
                                        @if (store.openHours.length > 0 && store._openPickupHour && orderType == 'pickup') {
                                          <ion-card-subtitle class="store_openHours_layout text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10,
                                          'alt_margin_adjust': this.settingService.configuration.uIoptions.homePageOption == 10}">{{ store._openPickupHour}} - {{store._closePickupHour}}</ion-card-subtitle>
                                        }
                                      </div>
                                    }
                                    <ion-card-subtitle class="text_adjust noWrapping" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">
                                      {{ store._distance | number:'1.2-2' }} km 
                                      @if (store.timeMin) {
                                        <span>• {{ store.timeMin }}-{{ store.timeMax }} Min • $</span>
                                      }
                                    </ion-card-subtitle>
                                  </div>
                                }
                                <div class="FlexLayout">
                                  @if (orderType == 'delivery') {
                                    <div>
                                      @if (store.deliveryMinAmount > 0) {
                                        <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.deliveryMinAmount | currency}} {{ 'Store.minDeliveryAmount' | translate}}</ion-card-subtitle>
                                      }
                                      @if (store.deliveryPrice > 0.00) {
                                        <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.deliveryPrice | currency }} {{ 'Store.Delivery' | translate}}
                                          @if (store.freeDelivery) {
                                            @if (store.freeDelivery.isAllowed) {
                                              <span style="color: red;">/ {{ 'Store.FreeOver' | translate}} {{ store.freeDelivery.price | currency }}</span>
                                            }
                                          }
                                        </ion-card-subtitle>
                                      }
                                    </div>
                                  }
                                  @if (orderType == 'shipping') {
                                    <div>
                                      @if (store.shippingMinAmount > 0) {
                                        <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">{{ store.shippingMinAmount | currency}} {{ 'Store.minShippingAmount' | translate}}</ion-card-subtitle>
                                      }
                                      @if (store.freeShipping) {
                                        <ion-card-subtitle class="text_adjust" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">
                                          @if (store.freeShipping.isAllowed) {
                                            <span style="color: red;">{{ 'General.Shipping' | translate}} {{ 'Store.freeOver' | translate}} {{ store.freeShipping.price | currency }}</span>
                                          }
                                        </ion-card-subtitle>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            @if(this.settingService.configuration.uIoptions.homePageOption != 10) {
                              <!--<div class="ion-card-right" *ngIf="store._disabled">-->
                              <div class="ion-card-right" [ngClass]="{ 'OrderLaterAdjust': validateClosing(store) }">
                                @if (!validateClosing(store)) {
                                  <input class="storeRadioBtn" type="radio" name="option" value="1" />
                                }
                                @if (validateClosing(store)) {
                                  <ion-card-subtitle class="text_adjust" style="display: flex; justify-content: center;" [ngClass]="{ 'alt_text_adjust': this.settingService.configuration.uIoptions.homePageOption == 10 }">
                                    <ion-button class="btnOrderLater" type="button" color="primary">
                                      {{ 'Store.OrderForLater' | translate}}
                                    </ion-button>
                                  </ion-card-subtitle>
                                }
                              </div>
                            }
                            
                          </div>
                          @if ((clickedStoreId === store.id && store._disabled)) {
                            <ion-card-content style="padding-top:0px;" class="TimeDateAdjustment">
                              <div style="width:100%;">
                                <!-- Old UI - 08/10/26 henry 
                                <div>
                                  <ion-select label="{{ menuDayPlaceholder }}" label-placement="stacked" (ionChange)="menuService.datePickerChanged(orderType)" class="date-picker" [(ngModel)]="menuService.order.orderDate">
                                    @for (days of menuService.getFollowingDays(orderType); track days) {
                                      <ion-select-option [value]="days.key">{{days.value}}</ion-select-option>
                                    }
                                  </ion-select>
                                  <div style="float:left; margin: 5px;">&#64;</div>
                                  <ion-select label="{{ menuTimePlaceholder }}" label-placement="stacked" (ionChange)="onTimeChange(store)" class="date-picker" [(ngModel)]="menuService.order.orderTime">
                                    @for (time of menuService.followingTime; track time; let i = $index) {
                                      <ion-select-option [value]="time.key">{{time.value}}</ion-select-option>
                                    }
                                  </ion-select>
                                </div>-->
                                @if(!settingService.configuration.requireTimeOfOrder){
                                  <div class="centeredDatepicker">
                                    <ion-select [placeholder]="translationService.translate(menuService.menuDayPlaceholder)" (ionChange)="menuService.datePickerChanged(orderType)" class="date-picker" [(ngModel)]="menuService.order.orderDate">
                                      @for (days of menuService.getFollowingDays(orderType); track days) {
                                        <ion-select-option [value]="days.key">{{days.value}}</ion-select-option>
                                      }
                                    </ion-select>
                                    <div style="float:left; margin: 5px;">&#64;</div>
                                    <ion-select  [placeholder]="translationService.translate(menuService.menuTimePlaceholder)" (ionChange)="onTimeConfirm(store)" class="date-picker" [(ngModel)]="menuService.order.orderTime">
                                      @for (time of menuService.followingTime; track time; let i = $index) {
                                        <ion-select-option [value]="time.key">{{time.value}}</ion-select-option>
                                      }
                                    </ion-select>
                                  </div>
                                }
                                @if(settingService.configuration.requireTimeOfOrder){
                                  @if (orderType == "pickup"){<ion-row><ion-col><h3  class="center text_adjust">{{ 'Menu.PickupTime' | translate}}</h3></ion-col></ion-row>}
                                  @if (orderType == "delivery"){<ion-row><ion-col><h3  class="center text_adjust">{{ 'Menu.DeliveryTime' | translate}}</h3></ion-col></ion-row>}
                                  <ion-row>
                                    <ion-col  class="center">
                                      <ion-select [placeholder]="translationService.translate(menuService.menuDayPlaceholder)" (ionChange)="menuService.datePickerChanged(orderType)" class="date-picker" [(ngModel)]="menuService.order.orderDate">
                                        @for (days of menuService.getFollowingDays(orderType); track days) {
                                          <ion-select-option [value]="days.key">{{days.value}}</ion-select-option>
                                        }
                                      </ion-select>

                                      <div class="text_adjust" style="float:left; margin: 5px;">&#64;</div>
                                      <ion-select  [placeholder]="translationService.translate(menuService.menuTimePlaceholder)" class="date-picker" [(ngModel)]="menuService.order.orderTime">
                                        @for (time of menuService.followingTime; track time; let i = $index) {
                                          <ion-select-option [value]="time.key">{{time.value}}</ion-select-option>
                                        }
                                      </ion-select>
                                    </ion-col>
                                  </ion-row>
                                  <div>
                                    <ion-card-subtitle class="text_adjust" style="display: flex; justify-content: center;">
                                      <ion-button [disabled]="!menuService.order.orderTime" class="btnOrderLater" type="button" color="primary" (click)="onTimeConfirm(store)" >
                                        {{ 'General.Confirm' | translate}}
                                      </ion-button>
                                    </ion-card-subtitle>
                                  </div>
                                }
                              </div>
                            </ion-card-content>
                          }
                          @if ((clickedStoreId === store.id && !store._disabled && settingService.configuration.requireTimeOfOrder)) {
                              <ion-card-content style="padding-top:0px;" class="TimeDateAdjustment">
                                <div style="width:100%;">
                                    @if (orderType == "pickup"){<ion-row><ion-col><h3  class="center text_adjust">{{ 'Menu.PickupTime' | translate}}</h3></ion-col></ion-row>}
                                    @if (orderType == "delivery"){<ion-row><ion-col><h3  class="center text_adjust">{{ 'Menu.DeliveryTime' | translate}}</h3></ion-col></ion-row>}
                                    <ion-row>
                                      <ion-col  class="center">
                                        <ion-select [placeholder]="translationService.translate(menuService.menuDayPlaceholder)" (ionChange)="menuService.datePickerChanged(orderType)" class="date-picker" [(ngModel)]="menuService.order.orderDate">
                                          @for (days of menuService.getFollowingDays(orderType); track days) {
                                            <ion-select-option [value]="days.key">{{days.value}}</ion-select-option>
                                          }
                                        </ion-select>

                                        <div class="text_adjust" style="float:left; margin: 5px;">&#64;</div>
                                        <ion-select  [placeholder]="translationService.translate(menuService.menuTimePlaceholder)" class="date-picker" [(ngModel)]="menuService.order.orderTime">
                                          @if (!menuService.order.orderDate){<ion-select-option [value]="null">{{'General.ASAP' | translate}}</ion-select-option>}
                                          @for (time of menuService.followingTime; track time; let i = $index) {
                                            <ion-select-option [value]="time.key">{{time.value}}</ion-select-option>
                                          }
                                        </ion-select>
                                      </ion-col>
                                    </ion-row>
                                    <div>
                                      <ion-card-subtitle class="text_adjust" style="display: flex; justify-content: center;">
                                        <ion-button class="btnOrderLater" type="button" color="primary" (click)="onTimeConfirm(store)" >
                                          {{ 'General.Confirm' | translate}}
                                        </ion-button>
                                      </ion-card-subtitle>
                                    </div>
                                </div>
                              </ion-card-content>
                            }
                        </ion-card-header>
                      </ion-card>
                    </a>
                  }
                </ion-col>
              }
            </ion-row>
            @if (storeCap < storeValidRange.length && showMoreStoreRangeComparison()) {
              <div class="ShowMoreContainer">
                <button (click)="showMoreStore();" class="ShowMoreStore">{{ 'Store.ShowMore' | translate }}</button>
              </div>
            }
          </ion-grid>
        }
      }

      @if (orderType == 'table' && allowTable) {
        @if (showScanner) {
          <zxing-scanner (scanSuccess)="scanSuccessHandler($event)" [ngClass]="{'collapsed': !showScanner}" style="margin-top: 15px;"></zxing-scanner>
        }
        <div style="display: flex; justify-content: center;">
          <ion-segment-button style="max-width: 380px;"  [ngClass]="{'segment-btn-clicked': showScanner}" class="button" (click)="toggleScanner();">
            <ion-label>{{ (showScanner ? 'Store.CloseScanner' : 'Store.ClickScanQRCode') | translate}}</ion-label>
          </ion-segment-button>
        </div>
        @if (showScanner) {
          <span style="margin: 1rem; margin-bottom: 0; padding-bottom: 1rem; text-align: center; display: block;">If you're having issues with the scanner on browser, use your photo camera app to start an order</span>
        }
        @if (tableOrders && tableOrders.length > 0) {
          <ion-content>
            @for (order of tableOrders; track order) {
              <ion-card >
                <a routerDirection="root" style="text-decoration: none;">
                  <ion-item>
                    <ion-label id="order-info">{{getLocalDate(order._orderDate.toString())}}<span style="margin-left: 1rem;">{{order._store.displayName}}</span></ion-label>
                    <button class="details" (click)="openOrder(order)">{{'General.Details' | translate}}</button>
                  </ion-item>
                </a>
              </ion-card>
            }
          </ion-content>
        }
      }
    </div>

    @if (newOrder) {
      <div  class="modal-new-cart">
          <div class="container-warning">
            <div class="new-order">{{'Store.Warning.NewOrderTitle' | translate}}</div>
            <p class="para">{{'Store.Warning.ParaPart1' | translate}}</p>
            <p class="para">{{'Store.Warning.ParaPart2' | translate}} {{ this.currentCartStore.displayName }} {{'.'}}</p>
            <p class="para">{{'Store.Warning.ParaPart3' | translate}} {{ this.storeAtProceed.displayName }}</p>
            <p class="para">{{'Store.Warning.ParaPart4' | translate}}</p>
            <div class="warningButtonsContainer">
              <button (click)="emptyOrderAndGoToStore()" class="btns" style="margin-bottom: 5px;">{{'Store.Warning.ContinuWith' | translate}} {{ this.storeAtProceed.displayName }}</button>
              <button (click)="closeWarning()" class="btns" id="no">{{'Store.Warning.ContinuWith' | translate}} {{ this.currentCartStore.displayName }}</button>
            </div>
          </div>
        </div>
    }
  }
</ion-content>